import { updateCurrentUserInfo } from '../services/auth';
import { ThemeMode } from '../types/User';

export const useUpdateTheme = () => {
  const updateTheme = async (theme: ThemeMode) => {
    await updateCurrentUserInfo({ theme: theme });
  };

  return { updateTheme };
};
